namespace Areas.TimeEntry {
    "use strict";

    var _employeeId: number;
    var _weekEnd: Date;
    var _submit: boolean;
    var _overtimeCalculated: boolean;

    export function submit (employeeId: number, weekEnd: Date) { 
        return (e:any) => {

            _employeeId = employeeId;
            _weekEnd = weekEnd;

            const url = `/TimeEntry/TimeEntry/ValidateTimeSheet/${employeeId}/${weekEnd}`;

            $.ajax({
                url: url,
                method: "GET",
                success: (response) => { 
                    $("#SubmitTimeSheetValidationError").text("");                   
                    checkHours(employeeId, weekEnd);
                },
                error: (response) => { $("#SubmitTimeSheetValidationError").text(response.responseText); }
            });

       }
    }


    export function approve(timeVerificationId: number) {
        return (e:any) => {

            const url = `/TimeEntry/TimeEntry/Approve/${timeVerificationId}`;

            $.ajax({
                url: url,
                method: "POST",
                success: (response) => { 
                    Areas.reloadPage();
                },
                error: (response) => { $("#SubmitTimeSheetValidationError").text(response.responseText); }
            });
       }
    }


    export function returnTimeSheet(timeVerificationId: number) {
        return (e: any) => {

            const url = `/TimeEntry/TimeEntry/ReturnTimeSheet/${timeVerificationId}`;

            $.ajax({
                url: url,
                method: "POST",
                success: (response) => {
                    Areas.reloadPage();
                },
                error: (response) => { $("#SubmitTimeSheetValidationError").text(response.responseText); }
            });
        }
    }


    function checkHours(employeeId, weekEnd) {
        $.ajax({
            url: `/TimeEntry/TimeEntry/WeekTotals/${employeeId}/${weekEnd}`,
            method: "GET",
            success: function (result) {
                if (result.isExempt || result.isFlexSchedule) {
                    var submitTimeDialog = new Areas.Dialogs.SubmitTime.SubmitTimeDialog(submitTimeDialogClosing);
                }
                else if (result.totalHours > 40 || result.totalHours < 40) {
                    var warningHoursDialog = new Areas.Dialogs.WarningHours.WarningHoursDialog(warningHoursDialogClosing);
                } else {
                    var submitTimeDialog = new Areas.Dialogs.SubmitTime.SubmitTimeDialog(submitTimeDialogClosing);
                } 
            },
            error: function (msg) {
                DevExpress.ui.notify("Error in request: " + msg.responseText, "error", 3000);
            }
        });
    }

    function warningHoursDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        var submitTimeDialog = new Areas.Dialogs.SubmitTime.SubmitTimeDialog(submitTimeDialogClosing);
    }

    function submitTimeDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        submitConfirm();
    }

    function submitConfirm() {
        
        $.ajax({
            url: "/TimeEntry/TimeEntry/Submit",
            method: "POST",
            data: { employeeId: _employeeId, weekEnd: _weekEnd },
            success: function (result) {

                if (result.hasOvertime && result.overTimeMethod.toUpperCase() != "NONE") {

                    _submit = true;

                    const parameters = {
                        straightHours: result.straightHours,
                        premiumHours: result.premiumHours,
                        employeeId: _employeeId,
                        weekEndDate: _weekEnd
                    }

                    var identifyWeeklyOvertimeDialog = new Areas.Dialogs.IdentifyWeeklyOvertime.IdentifyWeeklyOvertimeDialog(
                        identifyWeeklyOvertimeDialogClosing, parameters);
                   
                } else {
                    Areas.reloadPage();
                }
            },
            error: function (msg) {
                DevExpress.ui.notify("Error in request: " + msg.responseText, "error", 3000);
            }
        });
    }

    export function addDefaultJob(employeeId: number) {
        return (e: any) => {
            const parameters = {
                employeeId: employeeId
            }

            var addDefaultJobDialog = new Areas.Dialogs.AddDefaultJob.AddDefaultJobDialog(
                addDefaultJobDialogClosing, parameters);
        }
   }

    function addDefaultJobDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) {
            return;
        }

        Areas.refreshGrid("TimeSheetEntryGrid");
    }

    export function removeJob() {
        const grid = $("#TimeSheetEntryGrid").dxDataGrid("instance");
        const selectedKey = grid.getSelectedRowKeys()[0];

        if (selectedKey != null) {
            const verifyDelete = window.confirm("Are you sure you would like to delete this record?");

            if (!verifyDelete) {
                return;
            }

            const values = {

                employeeId: selectedKey.employeeId,
                accountWorkOrderId: selectedKey.accountWorkOrderId,
                taskCodeLk: selectedKey.taskCodeLk
            };

            var url = "/TimeEntry/Jobs/DeleteJob";
            Areas.sendRequest(url, JSON.stringify(values), "DELETE").done(() => Areas.refreshGrid("TimeSheetEntryGrid"));
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    function identifyWeeklyOvertimeDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) {
            _submit = false;
            _overtimeCalculated = false;

            const url = `/TimeEntry/TimeEntry/ClearOverTime/${_employeeId}/${_weekEnd}`;
            Areas.sendRequest(url, null, "POST");
            return;
        } 

        if (_submit) {
            submitConfirm();
        }
        else {
            _overtimeCalculated = true;
            getEmployeeOvertimeInformation(_employeeId, _weekEnd);
        }
    }
   
    export function getEmployeeOvertimeInformation(employeeId: number, weekEnd: Date) {

        _employeeId = employeeId;
        _weekEnd = weekEnd;

        $.ajax({
            url: "/TimeEntry/TimeEntry/GetEmployeeOvertimeInformation",
            method: "POST",
            data: { employeeId: _employeeId, weekEnd: _weekEnd },
            success: function (result) {

                if (result.hasOvertime === false) {
                    const toastrOptions = { timeOut: 4000, positionClass: "toast-top-full-width", showMethod: "show" };
                    toastr.info("All overtime hours have been calculated", "Info", toastrOptions);

                    if (_overtimeCalculated) {
                        Areas.reloadPage();
                    }
                }
                else {
                    _submit = false;

                    const parameters = {
                        straightHours: result.straightHours,
                        premiumHours: result.premiumHours,
                        employeeId: _employeeId,
                        weekEndDate: _weekEnd
                    }

                    var identifyWeeklyOvertimeDialog = new Areas.Dialogs.IdentifyWeeklyOvertime.IdentifyWeeklyOvertimeDialog(
                        identifyWeeklyOvertimeDialogClosing, parameters);
                } 
            },
            error: function (msg) {
                DevExpress.ui.notify("Error in request: " + msg.responseText, "error", 3000);
            }
        });
    }
    
    export function weekClick(url: string) {
        return () => {
            window.location.href = url;
        }
    }

    export function calendarClick() {
        var calendarDialog = 
            new Areas.Dialogs.Calendar.CalendarDialog(calendarDialogClosing);
    }

    function calendarDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const date = Areas.getPreviousSundayFromDate(data.date);

        window.location.href = "/Employee/Time/Index/" + $('#EmployeeId').val() + "?start=" + date.format("YYYY-MM-DD");
    }



}
